/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Wohin gehen wir?`
};

const en_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Where are we going?`
};

const es_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `¿Adónde vamos?`
};

const fr_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `On va où ?`
};

const it_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Dove stiamo andando?`
};

const nl_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Waar gaan we heen?`
};

const pt_search__input__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Para onde é que vamos?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search__input__aria_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search__input__aria_label", locale)
	if (locale === "de") return de_search__input__aria_label(inputs)
	if (locale === "en") return en_search__input__aria_label(inputs)
	if (locale === "es") return es_search__input__aria_label(inputs)
	if (locale === "fr") return fr_search__input__aria_label(inputs)
	if (locale === "it") return it_search__input__aria_label(inputs)
	if (locale === "nl") return nl_search__input__aria_label(inputs)
	return pt_search__input__aria_label(inputs)
};